import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import AlsoGoingOutGroupsApi from "../../api/AlsoGoingOutGroupsApi";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./GuestMode.scss";
import { getUserAvatar } from "../../utils/getMedia";
import BookingType from "../../api/enums/BookingType";
import { Modal } from "react-bootstrap";
import { AlsoGoingOutSelectedGroupContext } from "../../GlobalContext/selectedAlsoGoingOutGroupContext";
import { routes } from "../../routes/routes";
import { PartiesContext } from "../../GlobalContext/partiesContext";
import CreateJoinTableOfferApi from "../../api/CreateJoinTableOfferApi";
import AuthClient from "../../api/AuthClient";
import joinTableOfferRequest from "../../api/models/CreateJoinTableOfferModel";
import ValidationModals from "./ValidationModals";
import { CurrentPathContext } from "../../GlobalContext/currentPathContext";
import { FaArrowCircleLeft, FaArrowCircleRight, } from "react-icons/fa"
import Header from "../Header";
import { SendMessageCommandParameters } from "../../types";
import AuthenticationResponse from "../../api/responses/AuthenticationResponse";
import { localStorageKeys } from "../../utils/localStorageKeys";
import chatAttachmentType from "../../api/enums/ChatAttachmentType";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { iconsImgs } from "../../utils/icons";
import handleImgError from "../../handleImgError";
import { getCurrentCity } from "../../utils/currentCity";
import { SignalRContext } from "../../GlobalContext/signalRContext";

const AlsoGoingOutDetailPage = () => {

  const { ...alsoGoingOutGroupContextData } = useContext(AlsoGoingOutSelectedGroupContext);
  const { setSelectedAlsoGoingOutGroup } = useContext(AlsoGoingOutSelectedGroupContext);
  const { myPartiesInfo } = useContext(PartiesContext);
  const { sendMessage } = useContext(SignalRContext);
  const { groupId } = useParams<{ groupId: string }>();
  const [isFetchingGroup, setIsFetchingGroup] = useState(false);
  const [groupFetchFailed, setGroupFetchFailed] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isConfirmModalOpen, setConfirmationModalOpen] = useState(false);
  const [requestSentModal, setRequestSentModal] = useState(false);

  const [isInValidAgeOfMembers, setInValidAgeOfMembers] = useState(false);
  const [isAlreadyInvited, setAlreadyInvited] = useState(false);
  const [hostNotAcceptOffer, setHostNotAcceptOffer] = useState(false);

  const userInfo: AuthenticationResponse = JSON.parse(localStorage.getItem(localStorageKeys.loginResponse) as string);
  const mediaUrl = process.env.REACT_APP_MEDIA_URL;
  const baseURL = process.env.REACT_APP_BE_URL?.split('/app-apis')[0];


  const city = alsoGoingOutGroupContextData.party[0]?.city;
  const clubName = alsoGoingOutGroupContextData.requestedListing[0]?.clubName;

  const date = new Date(alsoGoingOutGroupContextData.party[0]?.partyDate);
  const formattedDate = `${date.getDate()}_${date.getMonth() + 1
    }_${date.getFullYear()}`;

  const constructedURLTableBooking = `${baseURL}/${city}/${clubName}/TableBooking/${formattedDate}`;
  const constructedURLGuestList = `${baseURL}/${city}/${clubName}/GuestList/${formattedDate}`;

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const formattedDayString = `${days[date.getDay()]} ${date.getDate()} ${months[date.getMonth()]}`;

  const onClickHandler = (joinRequest: boolean) => {

    const isMatchingGroup = myPartiesInfo.some((myParty) => {
      return (
        myParty.party.partyDate === alsoGoingOutGroupContextData.party[0].partyDate &&
        myParty.party.bookingType !== alsoGoingOutGroupContextData.party[0].bookingType
      );
    });

    if (isMatchingGroup && myPartiesInfo.some((myParty) => (BookingType[myParty.party.bookingType]).toString() === BookingType.TableBooking.toString()) && !joinRequest) {
      setConfirmationModalOpen(true);
    } else if (isMatchingGroup && myPartiesInfo.some((myParty) => (BookingType[myParty.party.bookingType]).toString() === BookingType.GuestList.toString()) && joinRequest) {

      const adminInvitation = myPartiesInfo[0].invitations.find(invitation => invitation.isGroupAdmin);

      if (adminInvitation) {

        const joinPhotoMessage: SendMessageCommandParameters = {
          FromUserId: adminInvitation.id,
          ChatRoomId: alsoGoingOutGroupContextData.party[0].id,
          MessageDate: new Date().toISOString(),
          CreatedAt: new Date().toISOString(),
          AttachmentLink: mediaUrl + adminInvitation.id,
          AttachmentType: chatAttachmentType.InternalImage,
          ThumbnailLink: mediaUrl + adminInvitation.id
        }
        sendMessage(joinPhotoMessage).then(() => {

          const joinTextMessage: SendMessageCommandParameters = {
            FromUserId: adminInvitation.id,
            Message: `${userInfo.firstName} asked if her group could join your group and go it together. Send their group an invite so you can chat to them once they accept. (You can not chat to them here)`,
            ChatRoomId: alsoGoingOutGroupContextData.party[0].id,
            MessageDate: new Date().toISOString(),
            CreatedAt: new Date().toISOString()
          }
          sendMessage(joinTextMessage).then(() => {

            setRequestSentModal(true);
          });
        });
      }

    } else {
      setModalOpen(true);
    }
  }

  const authClient = new AuthClient();

  function createJoiVIPTableOffer() {

    setConfirmationModalOpen(false);
    const api = new CreateJoinTableOfferApi(authClient);

    const hostParty = myPartiesInfo.filter((myParty) => {
      return myParty.party.partyDate === alsoGoingOutGroupContextData.party[0].partyDate &&
        myParty.party.bookingType !== alsoGoingOutGroupContextData.party[0].bookingType;
    });

    const filteredHostPartyOffer = hostParty[0].promotersOffers.map((promoter) =>
      promoter.offers.find((offer) => offer.isAccepted === true)
    ).filter((offer) => offer !== undefined);

    if (!filteredHostPartyOffer[0] || filteredHostPartyOffer.length === 0 || filteredHostPartyOffer[0].offerType !== "TableBooking") {
      console.log("No accepted offer found");
      setHostNotAcceptOffer(true);
      return false;
    }

    const isAlreadySendJoinTableOffer = alsoGoingOutGroupContextData.promoterOffers.some((promoter) =>
      promoter.offers.some((offer) => offer.offerType === "JoinVIPTable")
    );

    if (isAlreadySendJoinTableOffer) {
      console.log("Already invited");
      setAlreadyInvited(true);
      return false;
    }

    const requestModel: joinTableOfferRequest = {
      InvitedGroupId: alsoGoingOutGroupContextData.party[0].id,
      HostGroupId: hostParty[0].party.id,
      CityName: hostParty[0].party.city,
      ClubName: filteredHostPartyOffer[0].clubName
    }

    api.createJoinTableOffer(requestModel).then((result) => {
      if (result.badRequestMessage) {
        setInValidAgeOfMembers(true);
      } else {
        setConfirmationModalOpen(false);
      }
    });
  }

  const { currentPath } = useContext(CurrentPathContext);
  const navigate = useNavigate();
  const location = useLocation();

  // Fallback fetch: if user landed here via direct URL / refresh, context is empty.
  // Refetch the also-going-out groups for the current city and populate context from URL param.
  useEffect(() => {
    if (alsoGoingOutGroupContextData.invitations.length > 0) {
      return;
    }
    if (!groupId) {
      setGroupFetchFailed(true);
      return;
    }
    setIsFetchingGroup(true);
    const detailAuthClient = new AuthClient();
    const api = new AlsoGoingOutGroupsApi(detailAuthClient);
    const cityId = getCurrentCity(detailAuthClient.getAuthenticationResponse())?.cityId ?? null;
    api.getAlsoGoingOutGroups(cityId).then((response) => {
      if (response?.data) {
        const match = response.data.find((g) => g.party.id === groupId);
        if (match) {
          setSelectedAlsoGoingOutGroup(match.invitations, [match.party], match.requestedListings, match.promotersOffers);
        } else {
          setGroupFetchFailed(true);
        }
      } else {
        setGroupFetchFailed(true);
      }
      setIsFetchingGroup(false);
    }).catch(() => {
      setGroupFetchFailed(true);
      setIsFetchingGroup(false);
    });
  }, [groupId]);

  useEffect(() => {
    const handleBackNav = () => {
      try {
        if (currentPath === "rapp/alsoGoingOutGroupDetail") {
          console.log("Popped from alsogoingoutdetail"); //Debug log
          // navigate(routes.Root);
          window.removeEventListener('popstate', handleBackNav);
        }
      } catch (error) {
        console.log('Error handling back navigation:', error);
      }
    };

    window.addEventListener('popstate', handleBackNav);

    return () => {
      const string = window.location.pathname;
      const desiredPath = string.split("/")[1] + "/" + string.split("/")[2];

      if (desiredPath !== 'rapp/alsoGoingOutGroupDetail') {
        console.log("Popped from alsogoingoutdetail2"); //Debug log
        window.removeEventListener('popstate', handleBackNav);
      }
    };
  }, [location.pathname]);

  return (
    <>

      <ValidationModals anyUnderAgeMember={isInValidAgeOfMembers} setUnderAgeModal={setInValidAgeOfMembers} isAlreadyInvited={isAlreadyInvited}
        setAlreadyInvitedValue={setAlreadyInvited} hostNotAcceptOffer={hostNotAcceptOffer} setHostNotAcceptOffer={setHostNotAcceptOffer} />

      <Header />
      {alsoGoingOutGroupContextData.invitations.length > 0 ? (
        <>
          <div className="groupPromoter">
            <div className="desktopUI displayInline">
              <div className="row">

                <Breadcrumbs to={routes.GuestMode} />
                {alsoGoingOutGroupContextData.party[0]?.bookingType.toString() ===
                  BookingType[BookingType.GuestList] && (
                    <div className="d-flex justify-content-end space col-6">
                      <button
                        className="BtnTop yellowTxt btn text-decoration-none"
                        onClick={() => { onClickHandler(false) }}
                      >
                        Invite
                      </button>

                      <Modal
                        centered
                        show={isModalOpen}
                        onHide={() => setModalOpen(false)}
                      >
                        <Modal.Body className="text-center">
                          In order to invite this group to join your table you need to have a VIP table booked for {formattedDayString} in {alsoGoingOutGroupContextData.party[0]?.city}.
                        </Modal.Body>
                        <Modal.Footer>
                          <button
                            className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                            onClick={() =>
                              window.open(constructedURLTableBooking, "_blank")
                            }
                          >
                            Request Table Quote
                          </button>
                          <button
                            className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                            onClick={() => setModalOpen(false)}
                          >
                            Cancel
                          </button>
                        </Modal.Footer>
                      </Modal>

                      <Modal centered show={isConfirmModalOpen} onHide={() => setConfirmationModalOpen(false)}>
                        <Modal.Body className="text-center">
                          If you invite this group they accept your offer of joining your table. You are responsible for getting them in and pay cover charges and drinks.
                          If you do not make sure do nor make sure they get in this will be loged and affect your rating which reduces your chances of getting future invitations accepted.
                          Are you sure you want to send an invite?
                        </Modal.Body>

                        <Modal.Footer>
                          <button className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                            onClick={() => { createJoiVIPTableOffer() }}>
                            Yes
                          </button>
                          <button className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                            onClick={() => setConfirmationModalOpen(false)}>
                            No
                          </button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  )}

                {alsoGoingOutGroupContextData.party[0]?.bookingType.toString() ===
                  BookingType[BookingType.TableBooking] && (
                    <div className="d-flex justify-content-end space col-6">
                      <button
                        className="BtnTop yellowTxt btn text-decoration-none"
                        onClick={() => { onClickHandler(true) }}
                      >
                        Join
                      </button>

                      <Modal
                        centered
                        show={isModalOpen}
                        onHide={() => setModalOpen(false)}
                      >
                        <Modal.Body>
                          You need to have a guest list group for {formattedDayString} in {alsoGoingOutGroupContextData.party[0]?.city} in order to join a VIP table.
                        </Modal.Body>
                        <Modal.Footer>
                          <button
                            className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                            onClick={() =>
                              window.open(constructedURLGuestList, "_blank")
                            }
                          >
                            Request Guest List
                          </button>
                          <button
                            className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                            onClick={() => setModalOpen(false)}
                          >
                            Cancel
                          </button>
                        </Modal.Footer>
                      </Modal>

                      <Modal centered show={requestSentModal} onHide={() => setRequestSentModal(false)}>
                        <Modal.Body className="text-center">
                          Your request has been sent.
                        </Modal.Body>

                        <Modal.Footer>
                          <button className="link btns btnMO justify-content-center d-flex  align-content-center  col-12 mt-2 mb-2"
                            onClick={() => { setRequestSentModal(false) }}>
                            Ok
                          </button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  )}
              </div>

              <Carousel
                className={`row mt-4 swipe-container`}
                swipeable
                emulateTouch
                infiniteLoop={true}
                showStatus={false}
                renderIndicator={() => null}
                swipeScrollTolerance={100}
                showThumbs={false}
                renderArrowPrev={(clickHandler) => (
                  <div
                    className={`carousel-arrow left`}
                    onClick={clickHandler}
                  >
                    <FaArrowCircleLeft size={27} />
                  </div>
                )}
                renderArrowNext={(clickHandler) => (
                  <div
                    className={`carousel-arrow right`}
                    onClick={clickHandler}
                  >
                    <FaArrowCircleRight size={27} />
                  </div>
                )}

              >
                {alsoGoingOutGroupContextData.invitations.map((invitation, index) => (
                  <div key={invitation.id} className="carousel-slide p-0 m-0">
                    <div className="col-12">
                      <p className="yellowTxt m-0">Age: {invitation.age}</p>
                      <p className="yellowTxt m-0">
                        Tap on the picture to enable pinch zoom
                      </p>
                      <p className="yellowTxt">Swipe to see next guest</p>
                    </div>

                    <div className="col-12 justify-content-center align-content-center p-0">
                      <div className="promoter-imageContainer">
                        {Array.from({ length: parseInt(invitation.photos.toString()) !== 0 ? parseInt(invitation.photos.toString()) + 1 : invitation.photos }, (_, i) => (

                          <Link to={routes.PhotoZoom("alsoGoingOutGroupDetail", "0", alsoGoingOutGroupContextData.party[0].id, `${index}?photo=${i === 0
                            ? `${invitation?.id!}?${Date.now()}`
                            : `${invitation?.id!}${i}?${Date.now()}`}`)}
                            key={index}
                          >
                            <img
                              key={index + i}
                              src={getUserAvatar(
                                i === 0
                                  ? `${invitation?.id!}?${Date.now()}`
                                  : `${invitation?.id!}${i}?${Date.now()}`
                              )}
                              alt=""
                              style={{ pointerEvents: "all" }}
                              className="p-0 m-0 groupDetailImg img-fluid"
                              onError={(event) => handleImgError(event, invitation.gender.toString())}
                            />
                          </Link>
                        ))}

                        {parseInt(invitation.photos.toString()) === 0 &&

                          <Link to={routes.PhotoZoom("alsoGoingOutGroupDetail", "0", alsoGoingOutGroupContextData.party[0].id, `${index}?photo=${invitation.gender.toString()
                            === "Male" ? "male" : "female"}`)}
                            key={index}>

                            <img
                              src={invitation.gender.toString() === "Male" ? iconsImgs.Boy_96x96 : iconsImgs.Girl_96x96}
                              alt=""
                              style={{ pointerEvents: "all" }}
                              className="p-0 m-0 groupDetailImg img-fluid"
                            />
                          </Link>
                        }

                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>

              {/* <div className="row"> // -- Commented for now
                <div className="col-12 setPadding">
                  <button className="detailPageButton mt-4 mb-3">
                    REQUEST BETTER PHOTOS
                  </button>
                </div>
              </div> */}

            </div>
          </div>
        </>
      ) : isFetchingGroup ? (
        <p className="text-white text-center mt-4">Loading...</p>
      ) : groupFetchFailed ? (
        <p className="text-white text-center mt-4">Group not found.</p>
      ) : (
        <p className="text-white text-center mt-4">Loading...</p>
      )}
    </>
  );
};

export default AlsoGoingOutDetailPage;
